'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgFlash1Fill from '@common/icon/SvgFlash1Fill';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { POLICY_APPLICATION_TYPE } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { TermsAgreementCheckList } from '@/components/organism/TermsAgreementCheckList';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { jejuYouthDreamQueryOptions } from '@/query-factory/jeju-youthdream';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
interface QuickApplyButtonProps {
  policyApplyId: number;
  policyApplicationType: string;
}
export const QuickApplyButton = t0 => {
  const $ = _c(7);
  const {
    policyApplyId,
    policyApplicationType
  } = t0;
  const memberOAuth = useAuthStore(_temp);
  const isKbWebview = useDeviceInfoStore(_temp2);
  let t1;
  if ($[0] !== memberOAuth || $[1] !== policyApplyId) {
    t1 = jejuYouthDreamQueryOptions.applyList(memberOAuth, policyApplyId);
    $[0] = memberOAuth;
    $[1] = policyApplyId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const jejuApplyList = useInfiniteQuery(t1);
  let t2;
  bb0: {
    if (isKbWebview) {
      t2 = null;
      break bb0;
    }
    switch (policyApplicationType) {
      case POLICY_APPLICATION_TYPE.JEJU_CONSULTATION:
        {
          const jejuApplyListCount = jejuApplyList.data?.totalCount;
          if (jejuApplyListCount === undefined) {
            t2 = null;
            break bb0;
          }
          t2 = jejuApplyListCount ? "\uC81C\uC8FC\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC\uB0B4\uC5ED" : "\uC81C\uC8FC\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC\uC2E0\uCCAD";
          break bb0;
        }
      case POLICY_APPLICATION_TYPE.SCHOLARSHIP_FOUNDATION:
        {
          t2 = "\uD559\uC790\uAE08\uCC44\uBB34\uC790\uC2E0\uACE0";
          break bb0;
        }
      default:
        {
          t2 = null;
        }
    }
  }
  const applyType = t2;
  const router = useCustomRouter();
  const [isOpened, setIsOpened] = useState(false);
  let t3;
  if ($[3] !== applyType || $[4] !== isOpened || $[5] !== router) {
    t3 = applyType ? <><Button className="rounded-smal mb-12 w-full" dimensions="H48" onClick={e => {
        e.preventDefault();
        switch (applyType) {
          case "\uD559\uC790\uAE08\uCC44\uBB34\uC790\uC2E0\uACE0":
            {
              return router.push(ROUTES.POLICY_CONSENT.pathname);
            }
          case "\uC81C\uC8FC\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC\uC2E0\uCCAD":
            {
              return setIsOpened(true);
            }
          case "\uC81C\uC8FC\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC\uB0B4\uC5ED":
            {
              return router.push(ROUTES.MY_APPLY.pathname);
            }
        }
      }}><SvgFlash1Fill className="size-18" />{applyType === "\uC81C\uC8FC\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC\uB0B4\uC5ED" ? "\uC2E0\uCCAD\uB0B4\uC5ED" : "\uBC14\uB85C\uC2E0\uCCAD"}</Button>{applyType === "\uC81C\uC8FC\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC\uC2E0\uCCAD" ? <ResponsiveDialog opened={isOpened} onClose={() => setIsOpened(false)} ariaLabel={"\uC57D\uAD00 \uB3D9\uC758"} drawerType="bottom"><TermsAgreementCheckList /></ResponsiveDialog> : null}</> : null;
    $[3] = applyType;
    $[4] = isOpened;
    $[5] = router;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(state) {
  return state.myInfo?.memberOAuth;
}
function _temp2(state_0) {
  return state_0.webviewType === WEBVIEW_TYPE.KB_PAY;
}